// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { vmiCountsImportModalStyles } from "@insite/content-library/Components/VmiCountsImportModal";
import { fontConfig } from "@vanmeter/XDL/constants";
import { createLinkIconStyles, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiCountsImportModalStyles.buttonsGridItem = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

vmiCountsImportModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

vmiCountsImportModalStyles.importButton = {
    ...modalButtonsActionStyles.submitButton,
};

vmiCountsImportModalStyles.templateLink = {
    ...createLinkIconStyles({
        icon: "Download",
        sizeVariant: "small",
    }),
};

vmiCountsImportModalStyles.firstRowOptionCheckbox = {
    css: css`
        margin: 8px 0;
        display: block;
    `,
};

vmiCountsImportModalStyles.instructionText = {
    ...fontConfig.smallSingleLine,
    css: css`
        margin-bottom: 12px;
    `,
};

vmiCountsImportModalStyles.controlsGridItem = {
    width: 12,
    css: css`
        display: block;
        margin-bottom: 16px;
    `,
};

vmiCountsImportModalStyles.container = {
    gap: 12,
};

vmiCountsImportModalStyles.fileUploader = {
    mergeCss: true,
    buttonProps: {
        variant: "secondary",
    },
};
